import React from 'react'
import {inject,observer} from 'mobx-react'
import { withLayout } from '../utils/hoc'
import { withStyles } from 'material-ui/styles'

import { CircularProgress } from 'material-ui/Progress'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import AppBar from 'material-ui/AppBar'
import Toolbar from 'material-ui/Toolbar'
import IconButton from 'material-ui/IconButton'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import Button from 'material-ui/Button'
import { Link } from 'react-router-dom'
import StackGrid from 'react-stack-grid'
import { CatalogItem } from './catalog'
import { AddToCartButton,AddCollectionToCartButton } from './cart'
import Grid from 'material-ui/Grid'
import NewExampleForm from './newexampleform'
import T from 'i18n-react'
import { withCookies, Cookies } from 'react-cookie'
import { DeleteItemDialog } from './catalog'
import route from '../stores/fetchconfig.json'
import List, { ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction } from 'material-ui/List'
import Avatar from 'material-ui/Avatar'
import { withRouter } from 'react-router'
import { saveAs } from 'file-saver'
import Tooltip from 'material-ui/Tooltip'

import ExpansionPanel, {
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  ExpansionPanelActions,
} from 'material-ui/ExpansionPanel'
import { SmallToolbar } from './cart'


@inject('store','ui') @observer
class Collection extends React.Component {
  render () {
    const { store,classes } = this.props

    let label = ""
    if (store.exampleForm.asSuggestion) label = T.translate("newexampleform.asSuggestion")
    else if (store.exampleForm.asUpdate) label = T.translate("newexampleform.asUpdate")

    return (
      <div>
       <CollectionHeader classes={classes} />
       <CollectionContent classes={classes} />

       <NewExampleForm
        label={label}
        lehrplan={store.lehrplan}
        example={store.exampleForm.currentExample}

        asSuggestion={store.exampleForm.asSuggestion}
        sendSuggestion={store.sendSuggestion}

        asUpdate={store.exampleForm.asUpdate}
        sendUpdate={store.updateExample}
       />

       {store.isAuthorized && <DeleteItemDialog />}

      </div>
    )
  }

  componentWillMount () {
   this.props.store.getAllMetadata()
   let itemIDs = this.props.store.getParameterByName('s')
   const collectionId = this.props.store.getParameterByName('c')

   // c = published collection
   if (collectionId && collectionId !== "") {
     this.props.store.getCollectionDetailsFromPublishedCollection(collectionId)
   }

   // s = on the fly created collection
   else if (itemIDs && itemIDs !== "") {
    itemIDs = itemIDs.split(',')
    const title = this.props.store.getParameterByName('title')
    const description = this.props.store.getParameterByName('description')

    this.props.store.getCollectionDetails(itemIDs,title,description)
   }

  }

  componentDidMount () {
    const setWindowWidth = this.props.ui.collection.setWindowWidth

    window.addEventListener('resize',setWindowWidth)
    window.addEventListener('orientationchange',setWindowWidth)

    const { cookies } = this.props
    this.props.store.sudo(cookies.get('token'))
  }

}

@inject('store','ui','messenger') @observer
class CollectionHeader extends React.Component {
  render () {
    const { classes,store } = this.props
    const isLoading = store.collectionToInspect.createPdfFromCollectionLoading
    return (
      <AppBar className={classNames(classes.appBar)} position="fixed">
        <Toolbar disableGutters={true}>
         <Link to={route.endpoint + "/"} className={"unstyle-a " + classNames(classes.flex)} onClick={this.handleClick}>
          <IconButton color="inherit">
           <Icon>arrow_back</Icon>
          </IconButton>
         </Link>
         {isLoading
          ?
          <CircularProgress style={{color:'white',paddingRight:5}}/>
          :
          <Tooltip title={T.translate('meta.pdfCollection')} placement="bottom-start">
           <IconButton color="inherit" onClick={this.downloadCollection}>
            <Icon>save_alt</Icon> <span style={{paddingLeft:5}}>  </span>
           </IconButton>
          </Tooltip>
         }

        </Toolbar>
      </AppBar>
    )
  }

  downloadCollection = () => {
    this.props.store.collectionToInspect.setCreatePdfFromCollectionLoading(true)

    let itemIDs = this.props.store.getParameterByName('s')
    const collectionId = this.props.store.getParameterByName('c')
    let variant = '', payload = null

    if (itemIDs && itemIDs !== "") {
     variant = 's'
     payload = itemIDs
    }
    else if (collectionId && collectionId !== "") {
      variant = 'c'
      payload = collectionId
    }
    this.props.store.generatePDFForCollection(payload,variant,(blob) => {
      if (!blob.failedCreation) {
        const title = this.props.store.collectionToInspect.title ?
         this.props.store.collectionToInspect.title :
         this.props.store.collectionName + Math.random()*Math.random()

         saveAs(blob, title+'.pdf')
      } else {
       this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_DELETED)
      }
      this.props.store.collectionToInspect.setCreatePdfFromCollectionLoading(false)
    })
  }
}

@inject('store','ui') @withRouter @observer
class CollectionContent extends React.Component {
  render () {
    let  { classes,store,ui } = this.props,
           collection = store.collectionToInspect,
           items = collection.getCollectionGroupedByItemType()

    items = items.sort( (a,b) => {
      return a[0].typeId - b[0].typeId
    })

    return (
      <main className={classNames(classes.content)}>
      {!collection && <CircularProgress className="center-center" size={70} />}

      <Grid container direction="row" justify="center" alignItems="flex-start">
       <Grid item xs={12} sm={10} md={8}>

       {collection.title && <Typography type="display1" className={classes.title}> {collection.title} </Typography>}

       {collection.description && <Typography type="caption" className={classes.description}> {collection.description} </Typography>}

        {collection &&
         <div className={classes.contentSpacing}>
          {items.map( (group,i) => (
           <ExpansionPanel key={'group-'+i} defaultExpanded={(items.length === 1)}>
            <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>}>
             <Typography className={classes.heading}> {group[0].type.name} </Typography>
             {" "}<Typography variant="subheading" className={classes.secondaryHeading}> {'('+group.length+')'} </Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>

             <List>
              {group.map((item,j) => (
               <ListItem divider button key={"group-item-"+j} onClick={this.listitemevent.bind(this,item)}>
                <Avatar alt={item.title} src={item.image} />
                <ListItemText primary={item.title} secondary={store.getApproximatedTimevalue(item)}/>
                <ListItemSecondaryAction>
                 <AddToCartButton atCatalogView={true} item={item} />
                </ListItemSecondaryAction>
               </ListItem>
              ))}
             </List>

            </ExpansionPanelDetails>
           </ExpansionPanel>
          ))}
         </div>
        }

       </Grid>
      </Grid>

     </main>
    )
  }

  listitemevent (item) {
    const pathname = this.props.store.getItemTitleAsURLString(item.id,item.title)
    this.props.history.push(pathname)
  }
}



const styles = theme => ({
  title:{
   textAlign:'center',
   paddingBottom:25
  },
  description:{
   textAlign:'center'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    minWidth:40
  },
  appBar: {
    position: 'fixed',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentSpacing:{
    padding: theme.spacing.unit * 3,
  },
  category:{
    margin: "0.7em 0",
  },
  content: {
    width: '100%',
    overflow:'auto',
    overflowX:'hidden',
    flexGrow: 1,
    paddingTop:50,
    backgroundColor: theme.palette.background.default,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 'calc(100% - 64px)',
    marginTop: 64,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 64,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft:0,
    },
  },
  flex: {
    flex: 1,
  }
})

Collection.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}


export default withStyles(styles, { withTheme: true })(withLayout(withCookies(Collection)))



// WEBPACK FOOTER //
// ./src/components/collection.js